// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "table-module--base-text-alt--global--5a07c";
export var baseTextGlobal = "table-module--base-text--global--41bf8";
export var blockSpacing100 = "table-module--block-spacing-100--d7f13";
export var blockSpacing50 = "table-module--block-spacing-50--e108d";
export var blockVPadding100 = "table-module--block-v-padding-100--bc3ba";
export var blockVPadding50 = "table-module--block-v-padding-50--1c6f1";
export var border = "table-module--border--a8a63";
export var borderBottom = "table-module--borderBottom--9f769";
export var borderLeft = "table-module--borderLeft--88fb5";
export var borderRight = "table-module--borderRight--81dd5";
export var borderTop = "table-module--borderTop--40088";
export var captionTextGlobal = "table-module--caption-text--global--4afff";
export var cell = "table-module--cell--7ce00";
export var cellTitle = "table-module--cellTitle--1aa1e";
export var cmsRenderedContentGlobal = "table-module--cms-rendered-content--global--ff14c";
export var container = "table-module--container--55458";
export var contentContainer = "table-module--contentContainer--18fa1";
export var dark = "table-module--dark--24ee8";
export var defaultHSpacingGlobal = "table-module--default-h-spacing--global--51755";
export var empty = "table-module--empty--c8dea";
export var fadeInAnimation = "table-module--fadeInAnimation--56084";
export var fadeInOnLoadGlobal = "table-module--fade-in-on-load--global--3b0af";
export var fullHeightGlobal = "table-module--full-height--global--0fc4c";
export var fullHeightOmittingNavGlobal = "table-module--full-height-omitting-nav--global--3067f";
export var growAnimation = "table-module--growAnimation--1f775";
export var growIntoView = "table-module--growIntoView--307bd";
export var heading = "table-module--heading--7b072";
export var headingTextGlobal = "table-module--heading-text--global--0b119";
export var horizontal = "table-module--horizontal--d9aa4";
export var ingressTextGlobal = "table-module--ingress-text--global--2c114";
export var light = "table-module--light--de4b5";
export var linkColorChangeTransitionGlobal = "table-module--link-color-change-transition--global--05478";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "table-module--page-heading-text--global--5f179";
export var paragraphTextGlobal = "table-module--paragraph-text--global--905c8";
export var row = "table-module--row--05781";
export var subheadingTextGlobal = "table-module--subheading-text--global--023c4";
export var table = "table-module--table--ac807";
export var tableBody = "table-module--tableBody--df79c";
export var vertical = "table-module--vertical--e2b31";